$(function() {

	//animation
	$('.mv_base').on('inview', function (event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).addClass('mv');
		}
	});

	var headerHight = $("header .wrapper").height();
	$('a[href^="#"]').click(function(e) {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - headerHight;
		$.when(
			$("html, body").animate({
				scrollTop: position
			}, 400, "swing"),
			e.preventDefault(),
		).done(function() {
			var diff = target.offset().top - headerHight;
			if (diff === position) {} else {
				$("html, body").animate({
					scrollTop: diff
				}, 10, "swing");
			}
		});
	});

	//menu
	$(".menu-trg-area").click(function () {
		$("header").toggleClass("dark");
		$(".menu-trigger").toggleClass("active");
		$(".sp-menu").toggleClass("active");
	});
	$(".menu-link.parent").click(function () {
		$(this).toggleClass('active')
		$(this).next(".child").slideToggle();
	});

	//topics-slider
	$('.topics-slider').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		responsive: [
			{
				breakpoint: 1020,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '40px'
				}
			}
		],
	});

	$('.firstView .main-slider').not('.slick-initialized').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		fade: false,
		autoplaySpeed: 3000,
		autoplay: true,
		responsive: [
		{
			breakpoint: 1020,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		}],
	});

	$(".fv-news .close_btns").click(function () {
		$(".fv-news").fadeOut();
	})


	$('.item-block .item-name').matchHeight();
	$('.ranking-block .name').matchHeight();
	$('.item-block.var_product .post-category-list').matchHeight();

	$(document).ready(function() {
		if (window.matchMedia('(min-width: 1021px)').matches) {
			// アコーディオンの内部がクリックされたときは非表示にしない
			$('.toggle-wrapper').click(function(e) {
				e.stopPropagation();
			});

			$('.toggle-button').on('mouseenter', function(e) {
				// イベント伝播を停止
				e.stopPropagation();

				// クリックされたボタンのアコーディオンのIDを取得
				var targetId = $(this).attr('data-target');
				var $targetAccordion = $(targetId);

				// すべてのアコーディオンを非表示にする
				$('.toggle-wrapper').not($targetAccordion).fadeOut();

				// 対象のアコーディオンを表示する
				$targetAccordion.fadeIn();
			});

			$('.toggle-button').on('click', function(e) {
				// イベント伝播を停止
				e.stopPropagation();

				// クリックされたボタンのアコーディオンのIDを取得
				var targetId = $(this).attr('data-target');
				var $targetAccordion = $(targetId);

				// 対象のアコーディオンの表示状態を切り替える
				$targetAccordion.fadeToggle();
			});

			// ドキュメント全体のクリックイベントを監視
			$(document).click(function(e) {
				// クリックされた要素が.toggle-buttonまたは.toggle-wrapperでない場合のみアコーディオンを非表示にする
				if (!$(e.target).closest('.toggle-button, .toggle-wrapper').length) {
					// すべてのアコーディオンを非表示にする
					$('.toggle-wrapper').fadeOut();
				}
			});
		} else {
			$('.toggle-button').on('mouseenter click', function(e) {
				$("header").addClass("dark");
				$(".menu-trigger").addClass("active");
				$(".sp-menu").addClass("active");
			});
		}
	});

	$(window).scroll(function() {
		if ($(this).scrollTop() > 100) {
			$('header').addClass('active');
		} else {
			$('header').removeClass('active');
		}
	});

	$('#shopify-block-wishlist_hero_custom_product_button_3CbLUy').addClass('product-half');
	$('#shopify-block-wishlist_hero_custom_product_button_3CbLUy').prev('.product-block').addClass('product-half');
});

$(document).ready(function() {
	// 初期状態として最初のタブとアコーディオンの内容のみを表示し、最初のタブボタンにactiveクラスを追加
	$('.tab-accordion li').hide();
	$('.tab-accordion li').eq(0).show();
	$('.tab-buttons li').eq(0).addClass('active');

	// タブボタンがクリックされた時の処理
	$('.tab-buttons li').click(function() {
		// クリックされたタブのインデックスを取得
		var index = $(this).index();

		// 他の全てのタブボタンからactiveクラスを削除し、クリックされたタブボタンにactiveクラスを追加
		$('.tab-buttons li').removeClass('active');
		$(this).addClass('active');

		// すべてのアコーディオンをフェードアウト
		$('.tab-accordion li').hide();

		// クリックされたタブに対応するアコーディオンをフェードイン
		$('.tab-accordion li').eq(index).fadeIn();
	});

	//複数ある.variant__button-labelのstyle属性のbackground-colorを取得し、各.variant__button-labelに子要素spanを追加して、そのspanにbackground-colorを設定
	$(".variant-input-wrap[name='COLOR'] .variant__button-label").each(function() {
		var bgColor = $(this).attr("style");
		$(this).prepend("<span style='" + bgColor + "'></span>");
	});
});


$(document).ready(function() {
	$('#shopify-section-header li a').each(function() {
		var text = $(this).html();
		if (text.includes('[')) {
			var newText = text.replace('[', '<br>[');
			$(this).html(newText);
		}
	});
});

$(document).ready(function() {
	var urlParams = new URLSearchParams(window.location.search);
	var filterVendor = urlParams.get('filter.p.vendor');

	var catListLinks = document.querySelectorAll('.cat-list a');
	catListLinks.forEach(function(link) {
		var href = link.getAttribute('href');
		if (filterVendor) {
			var updatedHref = href + (href.includes('?') ? '&' : '?') + 'filter.p.vendor=' + filterVendor;
			link.setAttribute('href', updatedHref);
		}
	});
});


// ENページ閲覧中、サイト内リンクに/enが含まれていない場合追加
$(document).ready(function() {
	var currentUrl = window.location.href;
	if (currentUrl.includes('/en')) {
		$('a').each(function() {
			var href = $(this).attr('href');
			if (
				href &&
				!href.includes('/en') &&
				!href.startsWith('http') &&
				!href.startsWith('#') &&
				!$(this).closest('.locale-switcher').length
			) {
				$(this).attr('href', '/en' + href);
			}
		});
	}
});